import React from 'react';
import { Text, Flex, Box } from '@tonic-ui/react';
import { Trans } from 'react-i18next';
import { PLExternalButtonLink } from '../tonic-ui-overrides';

interface ExploreResourceTileProps {
  heading: string;
  description: string;
  linkUrl: string;
}

const ExploreResourceTile = ({
  heading,
  description,
  linkUrl,
}: ExploreResourceTileProps): JSX.Element => {
  return (
    <Flex
      background="white"
      boxShadow="0px 0px 24px rgba(0, 0, 0, 0.1)"
      borderRadius="12px"
      flexDirection="column"
      justifyContent="space-between"
      padding="50px"
      fontFamily="opensans"
      marginX={{ sm: '10%', md: '0' }}
      width={{ sm: '100%', md: '282px' }}
      height="400px"
    >
      <Box>
        <Text
          as="h3"
          margin="0"
          fontWeight={400}
          fontSize="24px"
          lineHeight="35px"
          textTransform="capitalize"
          marginBottom="4x"
          minHeight={{ md: '105px' }}
        >
          {heading}
        </Text>

        <Text fontWeight="300" fontSize="16px" lineHeight="22px">
          {description}
        </Text>
      </Box>
      <Box paddingTop="5x">
        <PLExternalButtonLink href={linkUrl}>
          <Trans i18nKey="publicLandingPage.learnMore" />
        </PLExternalButtonLink>
      </Box>
    </Flex>
  );
};

ExploreResourceTile.displayName = 'ExploreResourceTile';

export default ExploreResourceTile;
